import { ComponentType, ReactNode, useCallback, useState } from 'react'

type FolderItem = {
  path: string
  label: string
  Icon: ComponentType | (() => ReactNode)
}

type IconFolderProps = {
  label: string
  items: FolderItem[]
  onNavigate: (path: string) => void
}

export const IconFolder = ({ label, items, onNavigate }: IconFolderProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = useCallback(() => setIsOpen(true), [])
  const handleClose = useCallback(() => setIsOpen(false), [])

  const handleItemClick = useCallback(
    (path: string) => {
      setIsOpen(false)
      onNavigate(path)
    },
    [onNavigate],
  )

  // プレビュー用: 最大4つのアイコンを表示
  const previewItems = items.slice(0, 4)

  return (
    <>
      {/* フォルダアイコン */}
      <div className="flex h-full flex-col items-center justify-center gap-1">
        <div
          onClick={handleOpen}
          className="flex size-14 cursor-pointer items-center justify-center rounded-xl border border-white/20 bg-white/10 shadow-md backdrop-blur-sm"
          aria-label={label}
        >
          <div className="grid grid-cols-2 gap-0.5 p-1.5">
            {previewItems.map(({ path, Icon }) => (
              <div key={path} className="w-5 h-5 flex items-center justify-center [&_svg]:size-4!">
                <Icon />
              </div>
            ))}
          </div>
        </div>
        <span className="w-full truncate text-center text-[10px] leading-none">{label}</span>
      </div>

      {/* オーバーレイ */}
      {isOpen && (
        <div className="fixed inset-0 z-100 flex items-center justify-center" onClick={handleClose}>
          {/* 背景ブラー */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />

          {/* フォルダ内容 */}
          <div
            className="relative z-10 w-[85vw] max-w-sm rounded-2xl bg-white/15 backdrop-blur-xl border border-white/20 p-5 shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="text-center text-sm font-medium text-white mb-4">{label}</h3>
            <div className="grid grid-cols-4 gap-4 justify-items-center">
              {items.map(({ path, label: itemLabel, Icon }) => (
                <div key={path} className="flex flex-col items-center gap-1.5">
                  <div
                    onClick={() => handleItemClick(path)}
                    className="flex items-center justify-center w-14 h-14 cursor-pointer"
                    aria-label={itemLabel}
                  >
                    <Icon />
                  </div>
                  <span className="text-[10px] text-center leading-tight text-white/80 max-w-14 truncate">
                    {itemLabel}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
